import React from 'react'
import FaithCard from './FaithCard';
import FaithCardGod from './FaithCardGod';
import '../../../styles/containers/Prayer/components/faiths.scss';



function Faiths({page, selectedFaith, setSelectedFaith, setSelectedFaithObj, setSelectedGod, faiths}) {
    const getFaiths = () => {
        return faiths;
    }
    
    const handleClick = (faithKey) => {
        if(selectedFaith === faithKey) {
            setSelectedFaith('');
            setSelectedFaithObj({});
        } else {
            setSelectedFaith(faithKey);
            for(let faithObj of faiths) {
                if(faithObj.key === faithKey) {
                    setSelectedFaithObj(faithObj);
                    if(page === 'select-god')
                    setSelectedGod(faithObj.gods[0].key);
                }
            }
        }
    }

    const faithsList = getFaiths();
    let FaithsElement = [];
    for(let i = 0; i < faithsList.length; i+=2) {
        if(i + 1 < faithsList.length) {
            FaithsElement.push(
                <div key={i+1} className="row justify-content-between">
                    <div className="col d-flex justify-content-center col-margin" 
                    onClick={() => handleClick(faithsList[i].key)}
                    >
                        {page === 'select-god'?<FaithCardGod name={faithsList[i].name} symbol={selectedFaith === faithsList[i].key?faithsList[i].smallSelectedSymbol:faithsList[i].smallSymbol} faithSelected={selectedFaith === faithsList[i].key}/>:<FaithCard name={faithsList[i].name} symbol={faithsList[i].symbol} faithSelected={selectedFaith === faithsList[i].key}/>}
                    </div> 
                    <div className="col d-flex justify-content-center col-margin" 
                    onClick={() => handleClick(faithsList[i+1].key)}>
                        {page === 'select-god'?<FaithCardGod name={faithsList[i+1].name} symbol={selectedFaith === faithsList[i+1].key?faithsList[i+1].smallSelectedSymbol:faithsList[i+1].smallSymbol} faithSelected={selectedFaith === faithsList[i+1].key}/>:<FaithCard name={faithsList[i+1].name} symbol={faithsList[i+1].symbol}  faithSelected={selectedFaith === faithsList[i+1].key}/>}
                    </div>
                </div>
            )
        } else {
            FaithsElement.push(
                <div key={i+1} className="row justify-content-center">
                    <div className="col d-flex justify-content-center col-margin" 
                    onClick={() => handleClick(faithsList[i].key)}
                    >
                        {page === 'select-god'?<FaithCardGod name={faithsList[i].name} symbol={selectedFaith === faithsList[i].key?faithsList[i].smallSelectedSymbol:faithsList[i].smallSymbol} faithSelected={selectedFaith === faithsList[i].key}/>:<FaithCard name={faithsList[i].name} symbol={faithsList[i].symbol} faithSelected={selectedFaith === faithsList[i].key}/>}
                    </div>
                </div>
            )
        }
    }
    return (
        <div className='faiths-container' 
        style={page==='select-god'?{}:{marginBottom:'10px'}}
        >
            <div className="container-fluid">
                {FaithsElement}  
            </div>
        </div>
    )
}

export default Faiths
